/*
|
|--------------------------------------------------------------------------
| Barba - http://barbajs.org/
|--------------------------------------------------------------------------
| Create badass, fluid and smooth transition between your website's pages.
| It helps reducing the delay between your pages, minimizing browser
| HTTP requests and enhancing your user's web experience.
|
*/



//--------------------------------------------------------------------------
// Init Views - Add inits before start so evenest will be fired correctly
//--------------------------------------------------------------------------
Frontpage.init();
ProductPage.init();
ProductArchive.init();
Index.init();


//--------------------------------------------------------------------------
// Start Barba
//--------------------------------------------------------------------------
Barba.Pjax.start();
Barba.Prefetch.init();


//--------------------------------------------------------------------------
// Find the last link clicked so it can be used by transition-controller.js
//--------------------------------------------------------------------------
let lastClickEl;
Barba.Dispatcher.on('linkClicked', (el) => {
    lastClickEl = el;
});

//--------------------------------------------------------------------------
// Add no-barba to wp-admin header bar
//--------------------------------------------------------------------------
$( document ).ready(function() {
    $('#wpadminbar a').addClass('no-barba');
});


Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;

Barba.Pjax.preventCheck = function(evt, element) {
    if (!Barba.Pjax.originalPreventCheck(evt, element)) {
        return false;
    }

    // No need to check for element.href -
    // originalPreventCheck does this for us! (and more!)
    if (/.pdf/.test(element.href.toLowerCase()) || /product/.test(element.href.toLowerCase())) {
        return false;
    }

    return true;
};
